import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { Link } from 'react-router-dom';
import logo from "../../Assets/images/gif/danger.gif";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Select from 'react-select'; //04-03-2024-multiselect
import { use } from 'react';





export default function CourseEdit() {



  const [isEditable, setIsEditable] = useState(false);

  const [coursecode, setCoursecode] = useState(false);
  const [coursecodedigit, setCoursecodedigit] = useState(false);

  const [flagedit, setFalgedit] = useState(false);

  const [flag, setFalg] = useState(false);
  const [truet, setTrue] = useState(false);
  const [truet1, setTrue1] = useState(false);
  const [truet2, setTrue2] = useState(false);
  const [outcomee, setOutcome] = useState([]);
  const [course, setCourse] = useState([]);
  const [message, setMessage] = useState(false);
  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [coursecomponent, setCourseComponentData] = useState([]);
  const [coursecomponentstypes, setCoursecomponenttypeData] = useState([]);
  const [courselevel, setCourselevelData] = useState([]);
  const [learningdomain, setLearningdomainData] = useState([]);
  const [programmeoutcome, setProgrammeoutcomeData] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [facultyname, setFacultyname] = useState(false);
  const [showLecture, setShowLecture] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);
  const [showPracticumLab, setShowPracticumLab] = useState(false);

  const status = "active";
  const [semester, setSemester] = useState([]);
  const [courselevel1, setCourselevelData1] = useState([]);
  const [levelflag, setLevelflag] = useState(false);

  const [aecflag, setAecflag] = useState(false);
  const [minorflag, setMinorflag] = useState(false);
  const [minordata, setMinorData] = useState([]);

  const [ugpspecialisation, setugpspecialisation] = useState([]);
  const [ugpspecialisationflag, setugpspecialisationflag] = useState(false);

  const [courseType, setCourseType] = useState(false);

  const [theoryInternalEnabled, setTheoryInternalEnabled] = useState(false);
  const [theoryExternalEnabled, setTheoryExternalEnabled] = useState(false);

  const [practicalInternalEnabled, setPracticalInternalEnabled] = useState(false);
  const [practicalExternalEnabled, setPracticalExternalEnabled] = useState(false);
  const [commonError, setCommonError] = useState("");
  const [schemeId, setSchemeId] = useState(null);
  const [selectedDisciplineId, setSelectedDisciplineId] = useState(null);
  const [selectedAwardedDisciplineId, setSelectedAwardedDisciplineId] = useState(null);
  const [signatureCourseData, setSignatureCourseData] = useState([]);
  const [practicalCategoryType, setPracticalCategoryType] = useState('');

  const navigate = useNavigate();
  const { http } = Api();
  let { id, semid } = useParams();
  const decodedID = atob(id);
  const decodedSemID = atob(semid);

  sessionStorage.setItem("id", decodedID);

  const [lectureCredit, setLectureCredit] = useState(0);
  const [tutorialCredit, setTutorialCredit] = useState(0);
  const [practicalCredit, setPracticalCredit] = useState(0);

  const [lectureCredit1, setLectureCredit1] = useState(0);
  const [practicalCredit1, setPracticalCredit1] = useState(0);


  const [totalCredit, setTotalCredit] = useState(0);

  const [numSections, setNumSections] = useState(1);
  const [sectionsData, setSectionsData] = useState(Array.from({ length: 1 }, (_, index) => index + 1).map(() => ({ outcome: '', domains: [] }))); // Initialize with one section's data

  const [errors, setErrors] = useState({ cname: '', cfaculty: '', cdiscipline: '', ccurriculum: '', cinternal: '', cexternal: '', clevel: '', csemester: '', ccoursecode: '' });


  const [selectedCourseComponents, setSelectedCourseComponents] = useState([]);
  const [selectedCourseComponentsIDs, setSelectedCourseComponentsIDs] = useState([]);

  const [componentWiseData, setComponentWiseData] = useState({});



  const handleLectureCreditChange = (event) => {
    setTrue(true);
    const value = parseFloat(event.target.value);
    setLectureCredit(value);
  };


  const handleTutorialCreditChange = (event) => {
    setTrue(true);
    const value = parseFloat(event.target.value);
    setTutorialCredit(value);


  };


  const handlePracticalCreditChange = (event) => {
    setTrue(true);
    const value = parseFloat(event.target.value);
    setPracticalCredit(value);
  };




  useEffect(() => {


    const lecture = courseType === "P" ? 0 : lectureCredit1;
    const practical = courseType === "T" ? 0 : practicalCredit1;

    const total = Number(lecture) + Number(practical);


    if (total < 0 || total > 12) {
      setTotalCredit(0);
      toast.error('Total credit should be between 0 and 12');
    } else {
      setTotalCredit(total);
    }



  }, [practicalCredit1, lectureCredit1]);



  const [selectedDomainOptions, setSelectedDomainOptions] = useState(Array.from({ length: numSections }, () => []));
  const handleDomainChange1 = (selectedOptions, sectionIndex) => {
    setTrue2(true);
    setSelectedDomainOptions(prevSelectedDomainOptions => {
      const updatedSelectedDomainOptions = [...prevSelectedDomainOptions];
      updatedSelectedDomainOptions[sectionIndex] = selectedOptions;
      return updatedSelectedDomainOptions;
    });
  };


  const [selectedOutcomeOptions, setSelectedOutcomeOptions] = useState(Array.from({ length: numSections }, () => []));
  const handleOutcomeChange1 = (selectedOptions, sectionIndex) => {
    setTrue1(true);
    setSelectedOutcomeOptions(prevSectionsData => {
      const updatedSectionsData = [...prevSectionsData];
      updatedSectionsData[sectionIndex] = selectedOptions; // As
      return updatedSectionsData;
    });
  };



  // New code added for Course Outcomes in Edit mode
  // useEffect(() => {
  //   setSelectedDomainOptions(prev => {
  //     const updated = [...prev];
  //     while (updated.length < numSections) updated.push([]);
  //     return updated.slice(0, numSections);
  //   });

  //   setSelectedOutcomeOptions(prev => {
  //     const updated = [...prev];
  //     while (updated.length < numSections) updated.push([]);
  //     return updated.slice(0, numSections);
  //   });
  // }, [numSections]);


  // useEffect(() => {
  //   if (outcomee?.length) {
  //     setSelectedDomainOptions(
  //       outcomee.map(o =>
  //         o.concatenated_learning_domains
  //           ? o.concatenated_learning_domains.split(',').map(d => ({
  //               label: d.trim(),
  //               value: learningdomain.find(l => l.learning_domain === d)?.id
  //             }))
  //           : []
  //       )
  //     );

  //     setSelectedOutcomeOptions(
  //       outcomee.map(o =>
  //         o.concatenated_programme_outcomes
  //           ? o.concatenated_programme_outcomes.split(',').map(p => ({
  //               label: p.trim(),
  //               value: programmeoutcome.find(po => po.programme_outcome === p)?.id
  //             }))
  //           : []
  //       )
  //     );
  //   }
  // }, [outcomee]);

  //New code added for Course Outcomes in Edit mode End

  useEffect(() => {

    const { http } = Api();
    const id1 = sessionStorage.getItem("id");

    const fetchData = async () => {
      try {

        const response = await http.get(`/Admin/getCourseDetailsById/${id1}`);
        const response1 = await http.get(`/Admin/getfaculty`);

        const response2 = await http.get(`/Admin/getdiscipline`, {
          params: {
            limit: '500'
          }
        });
        const response3 = await http.get(`/Admin/getcoursecomponent`);
        // const response4 = await http.get(`/Admin/getcoursecurriculumcomponent`);
        const response5 = await http.get(`/Admin/getcourselevel`);
        const response6 = await http.get(`/Admin/getlearningdomain`);
        const response7 = await http.get(`/Admin/getprogrammeoutcome`);
        const response8 = await http.get(`/Admin/getsemester`);


        setCourse(response.data.Course);
        setOutcome(response.data.Outcome);
        setFacultyData(response1.data.data);
        setDisciplineData(response2.data.data);
        setCourseComponentData(response3.data);

        setCourselevelData(response5.data);
        setLearningdomainData(response6.data);
        setProgrammeoutcomeData(response7.data);
        setSemester(response8.data);
        // setCoursecomponenttypeData(response9.data);
        if (response.data.Course[0].specialisation_id != 0 && response.data.Course[0].specialisation_id != null) {
          setugpspecialisationflag(true);

        }
        const codeToKey = {
          L: 'lecture',
          T: 'tutorial',
          PCP: 'practicum',
          PLP: 'practical',
          FW: 'fieldwork',
          S: 'seminar',
          A: 'assignment',
          O: 'OJT',
          INT: 'internship',
          OTH: 'others',
          PJ: 'project',
        };

        const componentsdata = response.data;
        const components = componentsdata.CourseComponents || [];
        const creditHours = componentsdata.CreditHours || {};

        // Prepare react-select value
        const selected = components.map(c => ({
          value: c.id,
          label: c.course_component,
          code: c.course_component_code,
        }));
        setSelectedCourseComponents(selected);

        // Prepare component-wise credit/hour data
        const componentData = {};

        components.forEach(component => {
          const key = codeToKey[component.course_component_code];
          if (!key) return;

          componentData[component.id] = {
            componentName: component.course_component,
            total_credit: creditHours[`${key}_credit`] ?? '',
            total_hours: creditHours[`${key}_hours`] ?? '',
          };
        });

        setComponentWiseData(componentData);


        if (response.data.Course[0].coursetype == 'B') {
          setTheoryInternalEnabled(true);
          setTheoryExternalEnabled(true);
          setPracticalInternalEnabled(true);
          setPracticalExternalEnabled(true);
        }
        else if (response.data.Course[0].coursetype == 'T') {
          setTheoryInternalEnabled(true);
          setTheoryExternalEnabled(true);
          setPracticalInternalEnabled(false);
          setPracticalExternalEnabled(false);
        }
        else if (response.data.Course[0].coursetype == 'P') {
          setTheoryInternalEnabled(false);
          setTheoryExternalEnabled(false);
          setPracticalInternalEnabled(true);
          setPracticalExternalEnabled(true);
        }

        if (response.data.Course.length === 1) {

          setNumSections(response.data.Course[0].outcome_number);
          const initialTotal = response.data.Course[0].outcome_number === 0 ? 1 : response.data.Course[0].outcome_number;
          setSectionsData(Array.from({ length: initialTotal }, (_, index) => index + 1).map(() => ({ outcome: '', domains: [] })));

          if (response.data.Course[0].credit_lecture > 0) {
            setShowLecture(true);
            setLectureCredit(response.data.Course[0].credit_lecture);
          }
          if (response.data.Course[0].credit_tutorial > 0) {
            setShowTutorial(true);
            setTutorialCredit(response.data.Course[0].credit_tutorial);
          }
          if (response.data.Course[0].credit_practical > 0) {
            setShowPracticumLab(true);
            setPracticalCredit(response.data.Course[0].credit_practical);
          }
          // setTotalCredit(response.data.Course[0].credit_practical + response.data.Course[0].credit_tutorial + response.data.Course[0].credit_lecture);
        } else {
          setMessage("No course data found or multiple courses returned.");
        }

        // used to select initial values to LTP

        if (!truet) {
          const selectedValues = response3.data.filter(coursecomponents => {


            const componentIds = JSON.parse(response.data.Course[0].concatenated_course_components_id);
            return componentIds.includes(coursecomponents.id);

          }).map(selectedComponent => selectedComponent.id);

          setSelectedCourseComponents(selectedValues);
        }

        //used to select initial value to coursecomponents
        if (!truet2) {

          for (let i = 0; i < response.data.Course[0].outcome_number; i++) {

            const concatenatedDomains = response.data.Outcome[i].concatenated_learning_domains.split(',').map(domain => domain.trim());

            const selectedOptions = response6.data.filter(learningdomains => concatenatedDomains.includes(learningdomains.learning_domain))
              .map(selectedOption => ({
                value: selectedOption.id,
                label: selectedOption.learning_domain
              }));

            const k = i;


            handleDomainChange1(selectedOptions, k);

          }
        }
        //used to select initial value to coursedomine
        if (!truet1 && response.data.Course[0].outcome_number > 0) {
          for (let i = 0; i < response.data.Course[0].outcome_number; i++) {
            const concatenatedDomains = response.data.Outcome[i].concatenated_programme_outcomes.split(',').map(domain => domain.trim());

            const selectedOptions = response7.data.filter(programmeoutcomes => concatenatedDomains.includes(programmeoutcomes.programme_outcome))
              .map(selectedOption => ({
                value: selectedOption.id,
                label: selectedOption.programme_outcome
              }));

            const k = i;



            handleOutcomeChange1(selectedOptions, k);
          }
        }

      } catch (error) {
        console.error('Error fetching Course data:', error);
      }
    };

    fetchData();

  }, []);


  //new code added for specialisation selectbox
  useEffect(() => {

    if (ugpspecialisationflag) {

      http.get(`/Admin/getugpspecialisation`, {
        params: {
          discipline: course[0].discipline_id
        }
      })
        .then(response => {

          setugpspecialisation(response.data);
          setMinorflag(false);
          setAecflag(false);
          setMinorData([]);

        })
        .catch(error => {

          setugpspecialisation([]);
          setMinorflag(false);
          setAecflag(false);

        });

    }

  }, [ugpspecialisationflag]);
  //new code added for specialisation selectbox end


  useEffect(() => {
    const fectchSignatureCourseData = () => {
      http.get('/Admin/getSignatureCourseData', {
        params: {
          course_code: course[0].course_code
        }
      }).then(response => {
        //console.log("response==", response)
        setSignatureCourseData(response.data);
      }).catch(error => {
        console.error('Error fetching Signature Course data:', error);

      });
    }
    if (course.length > 0) {
      fectchSignatureCourseData();
    }

  }, [course]);

  useEffect(() => {

    const geta = () => {

      if (discipline.length > 0 && course.length > 0) {
        const selectedDiscipline = discipline.find(d => d.id === course[0].discipline_id);
        setSchemeId(selectedDiscipline.scheme_id);

        http.get('/Admin/getcourseComponentStructure', {
          params: {
            semester_id: decodedSemID,
            scheme_id: selectedDiscipline.scheme_id
          }
        }).then(response4 => {
          setCoursecomponenttypeData(response4.data);
        }).catch(error => {
          console.error('Error fetching Course data:', error);
        });

      }
    }
    if (discipline.length > 0 && course.length > 0) {
      geta();

    }

  }, [discipline]);


  const handleDisciplineChange = (event) => {
    const selectedId = event.target.value;
    setSelectedDisciplineId(selectedId);

    const selectedDiscipline = discipline.find(d => d.id == selectedId);
    if (selectedDiscipline) {
      setSchemeId(selectedDiscipline.scheme_id);
      sessionStorage.setItem("scheme_id", selectedDiscipline.scheme_id);
    }

    course_code(event);
  };

  useEffect(() => {
    if (course.length === 0) {

    } else if (course[0].faculty_id) {

      setFacultyname(course[0].faculty_id);
    }
  }, [course]);

  const learningoptions = learningdomain.map(learningdomains => ({
    value: learningdomains.id,
    label: learningdomains.learning_domain
  }));

  const outcomeoptions = programmeoutcome.map(programmeoutcomes => ({
    value: programmeoutcomes.id,
    label: programmeoutcomes.programme_outcome
  }));

  const handleCourseOutcomeChange = (event) => {
    let value = parseInt(event.target.value);
    value = Math.max(1, Math.min(value, 20));
    setNumSections(value);
    setSectionsData(Array.from({ length: value }, (_, index) => index + 1).map(() => ({ outcome: '', domains: [] })));
  };

  const handleOutcomeChange = (selectedOptions, sectionIndex) => {
    setTrue1(true);
    const updatedSelectedOutcomeOptions = [...selectedOutcomeOptions];
    updatedSelectedOutcomeOptions[sectionIndex] = selectedOptions;
    setSelectedOutcomeOptions(updatedSelectedOutcomeOptions);
  };

  const handleDomainChange = (selectedOptions, sectionIndex) => {
    setTrue2(true);
    const updatedSelectedDomainOptions = [...selectedDomainOptions];
    updatedSelectedDomainOptions[sectionIndex] = selectedOptions;
    setSelectedDomainOptions(updatedSelectedDomainOptions);
  };

  const isAuth = useAuth();
  if (isAuth === false) {
    window.location.reload();
  }


  const handleCourseComponentChangeold = (selectedOptions) => {

    setTrue(true);
    const selectedValues = selectedOptions.map(option => option.value);
    setSelectedCourseComponents(selectedValues);

    selectedOptions.forEach(option => {
      if (option.value === 1) {
        setShowLecture(true);
      } else if (option.value === 2) {
        setShowTutorial(true);
      } else if (option.value === 3 || option.value === 4) {
        setShowPracticumLab(true);
      }
    });

    // Hide components that are not selected
    if (!selectedOptions.some(option => option.value === 1)) {
      setShowLecture(false);
      setLectureCredit(0);
    }
    if (!selectedOptions.some(option => option.value === 2)) {
      setShowTutorial(false);
      setTutorialCredit(0);
    }
    if (!selectedOptions.some(option => option.value === 3 || option.value === 4)) {
      setShowPracticumLab(false);
      setPracticalCredit(0);
    }
    // if (selectedValues.length === 0) {
    //   setTotalCredit(0);
    // }

  };
  const handleCourseComponentChange = (selectedOptions) => {
    setTrue(true);

    const selectedValues = selectedOptions.map(opt => opt.value);
    setSelectedCourseComponentsIDs(selectedValues);

    setSelectedCourseComponents(selectedOptions || []);

    setComponentWiseData(prev => {
      const updated = {};

      (selectedOptions || []).forEach(opt => {
        updated[opt.value] = prev[opt.value] ?? {
          componentName: opt.label,
          total_credit: '',
          total_hours: '',
        };
      });

      return updated; // removed components automatically dropped
    });
  };


  const courseComponentDetails = Object.entries(componentWiseData).map(
    ([component_id, data]) => ({
      component_id: parseInt(component_id),
      total_credit: Number(data.total_credit),
      total_hours: Number(data.total_hours),
    })
  );
  const total_credit = courseComponentDetails.reduce(
    (sum, c) => sum + c.total_credit,
    0
  );

  const total_hours = courseComponentDetails.reduce(
    (sum, c) => sum + c.total_hours,
    0
  );


  const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;


    const course_name = document.getElementById('course_code').value;
    const faculty_id = document.getElementById('faculty_id').value;
    const discipline_id = document.getElementById('discipline_id').value;
    const awarded_discipline_id = document.getElementById('awarded_discipline_id').value;
    const course_curriculum_structure_component_id = document.getElementById('coursecomponentstype').value;
    // const internal_ratio = document.getElementById('internal_ratio').value;
    // const external_ratio = document.getElementById('external_ratio').value;
    const course_level = document.getElementById('courselevel_id').value;
    const semesterid = document.getElementById('semester_id').value;

    const course_ty = document.getElementById('courseidoftype').value;

    let coursecodelen = document.getElementById('inlineFormCourseCode').value;

    // Specialisation validation only if visible
    const specDropdown = document.getElementById("ugpspecialisation_group");
    const specRow = document.getElementById("spec_row");
    const practRow = document.getElementById("pract_row");

    // TRUE if div is shown
    const isSpecVisible = specRow && specRow.offsetParent !== null;
    const isPractVisible = practRow && practRow.offsetParent !== null;

    const practicalTypeexist = document.getElementById('practicalType');

    const practical_type = practicalTypeexist ? practicalTypeexist.value : "";





    if (errors.ccoursecode) {
      updatedErrors.ccoursecode = 'enter a valid number';
      hasError = true;
    }

    if (course[0].course_code.length !== 12) {
      updatedErrors.ccoursecode = 'Length must be 12';
      hasError = true;
    }
    // Old code
    // if (!/^\d{3}$/.test(coursecodelen)) {
    //   updatedErrors.ccoursecode = 'Last 3 characters must be numbers';
    //   hasError = true;
    // }
    // Old code end
    if (signatureCourseData.length === 0) {
      // Only validate if NOT a signature course
      if (!/^\d{3}$/.test(coursecodelen)) {
        updatedErrors.ccoursecode = 'Last 3 characters must be numbers';
        hasError = true;
      }
    }


    if (!course_name) {
      updatedErrors.cname = 'enter a course name';
      hasError = true;
    }

    if (course_ty === "0") {
      updatedErrors.ccoursetype = 'select  a Course Type';
      hasError = true;
    }

    if (faculty_id === "0") {
      updatedErrors.cfaculty = 'select  a faculty';
      hasError = true;
    }

    if (discipline_id === "0") {

      updatedErrors.cdiscipline = 'select a discipline';
      hasError = true;
    }

    if (awarded_discipline_id === "0") {

      updatedErrors.cawardedDiscipline = 'select an awarded discipline';
      hasError = true;
    }

    if (semesterid === "0") {

      updatedErrors.csemester = 'select a semester';
      hasError = true;
    }
    if (isSpecVisible) {
      const specValue = specDropdown.value;

      if (specValue === "") {
        updatedErrors.specialisation = "Please select a specialisation";
        hasError = true;
      }
    }
    if (isPractVisible) {
      const practicalTypeValue = practical_type;

      if (practicalTypeValue === "") {
        updatedErrors.practicalType = "Select a practical category";
        hasError = true;
      }
    }
    setCommonError("");

    if (
      (theoryInternalEnabled && (!document.getElementById('theoryMin').value || !document.getElementById('theoryMax').value)) ||
      (theoryExternalEnabled && (!document.getElementById('theoryExternalMin').value || !document.getElementById('theoryExternalMax').value)) ||
      (practicalInternalEnabled && (!document.getElementById('practicalInternalMin').value || !document.getElementById('practicalInternalMax').value)) ||
      (practicalExternalEnabled && (!document.getElementById('practicalExternalMin').value || !document.getElementById('practicalExternalMax').value))
    ) {
      toast.error("An error occured in Mark Details");
      document.getElementById("Mark_Details").scrollIntoView({ behavior: 'smooth', block: 'start' });
      setCommonError("Please fill all required fields in Mark Details section");
      //setCommonError("Please fill all required fields in Mark Details section or disable the corresponding options");
      return; // Stop form submission
    }


    if (course_curriculum_structure_component_id === "") {

      updatedErrors.ccurriculum = 'select a course curriculum structure component';
      hasError = true;
    }
    if (total_credit !== totalCredit) {
      toast.error("Total credit you entered does not match the calculated total credit");
      return;

    }
    // if (!internal_ratio) {
    //   updatedErrors.cinternal = 'enter internal ratio';
    //   hasError = true;
    // }

    // if (!external_ratio) {
    //   updatedErrors.cexternal = 'enter external ratio';
    //   hasError = true;
    // }

    if (course_level === "0") {
      updatedErrors.clevel = 'selct a course level';
      hasError = true;
    }
    {/* Credit and Hours Section */ }

    if (Object.keys(componentWiseData).length === 0) {
      updatedErrors.courseComponent = "Select at least one course component";
      hasError = true;
    } else {
      updatedErrors.componentErrors = {};

      Object.entries(componentWiseData).forEach(([id, component]) => {
        const compError = {};

        if (!component.total_credit || Number(component.total_credit) <= 0) {
          compError.total_credit = "Enter valid credit";
          hasError = true;
        }

        if (!component.total_hours || Number(component.total_hours) <= 0) {
          compError.total_hours = "Enter valid hours";
          hasError = true;
        }

        if (Object.keys(compError).length > 0) {
          updatedErrors.componentErrors[id] = compError;
        }
      });

      if (Object.keys(updatedErrors.componentErrors).length === 0) {
        delete updatedErrors.componentErrors;
      }
    }
    {/* Credit and Hours Section end */ }


    if (hasError) {
      setErrors(updatedErrors);
      return false;

    } else {
      setErrors({ cname: '', cfaculty: '', cdiscipline: '', ccurriculum: '', cinternal: '', cexternal: '', clevel: '' });
      return true;
    }

  };



  const cancelForm = () => {
    navigate("/admin/course");
  };


  // const courseComponentDetails = Object.entries(componentWiseData).map(
  //   ([component_id, data]) => ({
  //     component_id: parseInt(component_id),
  //     total_credit: Number(data.total_credit),
  //     total_hours: Number(data.total_hours),
  //   })
  // );
  // const total_credit = courseComponentDetails.reduce(
  //   (sum, c) => sum + c.total_credit,
  //   0
  // );

  // const total_hours = courseComponentDetails.reduce(
  //   (sum, c) => sum + c.total_hours,
  //   0
  // );


  const saveForm = () => {

    if (validateForm()) {
      const course_name = document.getElementById('course_code').value;
      const faculty_id = document.getElementById('faculty_id').value;
      const discipline_id = document.getElementById('discipline_id').value;
      const awarded_discipline_id = document.getElementById('awarded_discipline_id').value;
      // const credit_lecture = showLecture ? document.getElementById('lecture').value.trim() : 0;
      // const credit_tutorial = showTutorial ? document.getElementById('tutorial').value.trim() : 0;
      // const credit_practical = showPracticumLab ? document.getElementById('practical').value.trim() : 0;
      const course_curriculum_structure_component_id = document.getElementById('coursecomponentstype').value;
      const course_level = document.getElementById('courselevel_id').value;
      const semesterid = document.getElementById('semester_id').value;
      const number_of_outcome = document.getElementById('courseoutcome').value;
      const remarksValue = document.getElementById('remarks').value;

      let coursecode1 = document.getElementById('inlineFormCourseCode').value;
      let coursecode2 = flagedit ? coursecode : course[0].course_code.slice(0, -3);
      let coursecode3 = coursecode2 + coursecode1;



      const course_ty = document.getElementById('courseidoftype').value === "0" ? 0 : document.getElementById('courseidoftype').value;

      const practicalTypeexist = document.getElementById('practicalType');
      const practical_type = practicalTypeexist ? (practicalTypeexist.value === "0" ? 0 : practicalTypeexist.value) : "";

      const courseType_theory = course_ty === "T" || course_ty === "B" ? lectureCredit1 : 0;
      const courseType_practical = course_ty === "P" || course_ty === "B" ? practicalCredit1 : 0;
      const credit_total = totalCredit;

      const aec_group = aecflag ? document.getElementById('aec_group').value : null;
      const min_group = minorflag ? document.getElementById('minor_group').value : null;
      const ugpspecialisation_group = ugpspecialisationflag ? parseInt(document.getElementById('ugpspecialisation_group').value) : 0;

      const theoryInternalMin = theoryInternalEnabled ? document.getElementById('theoryMin').value : null;
      const theoryInternalMax = theoryInternalEnabled ? document.getElementById('theoryMax').value : null;
      const theoryExternalMin = theoryExternalEnabled ? document.getElementById('theoryExternalMin').value : null;
      const theoryExternalMax = theoryExternalEnabled ? document.getElementById('theoryExternalMax').value : null;

      const practicalInternalMin = practicalInternalEnabled ? document.getElementById('practicalInternalMin').value : null;
      const practicalInternalMax = practicalInternalEnabled ? document.getElementById('practicalInternalMax').value : null;
      const practicalExternalMin = practicalExternalEnabled ? document.getElementById('practicalExternalMin').value : null;
      const practicalExternalMax = practicalExternalEnabled ? document.getElementById('practicalExternalMax').value : null;


      const status = "active";
      const outcomes = [];


      //const selectedCourseComponentsids = selectedCourseComponentsIDs.map(component => parseInt(component));
      //new comment 
      // const selectedCourseComponentsids = selectedCourseComponents.map(component => Number(component.value));
      const selectedCourseComponentsidsqqq =
        selectedCourseComponents.map(component => Number(component));



      let selectedCourseComponentsids = [];

      if (selectedCourseComponentsIDs.length > 0) {

        selectedCourseComponentsids = selectedCourseComponentsIDs.map(component => Number(component));
      } else {

        selectedCourseComponentsids = selectedCourseComponents.map(component => parseInt(component));
      }

      const selectedCourseComponentsidsq =
        selectedCourseComponents.length > 0
          ? selectedCourseComponents.map(c => parseInt(c.value))
          : JSON.parse(course[0].concatenated_course_components_id);



      // console.log(course_name, faculty_id, discipline_id, course_curriculum_structure_component_id, course_level, semesterid, number_of_outcome, remarksValue, coursecode1, coursecode2, coursecode3, course_ty, courseType_theory, courseType_practical, credit_total, aec_group, min_group, theoryInternalMin, theoryInternalMax, theoryExternalMin, theoryExternalMax, practicalInternalMin, practicalInternalMax, practicalExternalMin, practicalExternalMax, status, selectedCourseComponentsids);
      //alert(number_of_outcome);

      for (let i = 0; i < number_of_outcome; i++) {
        try {
          const outcomeDescription = document.getElementById(`outcome${i}`).value;
          const learningDomainIds = selectedDomainOptions[i]?.map(option => option.value) || []; // Handle potential undefined or missing data
          const programme_outcome = selectedOutcomeOptions[i]?.map(option => option.value) || [];
          //alert(`Outcome ${i + 1} Description: ${outcomeDescription}, Learning Domain IDs: ${learningDomainIds.join(', ')}, Programme Outcome IDs: ${programme_outcome.join(', ')}`);

          if (!outcomeDescription || !learningDomainIds.length || !programme_outcome.length) {
            toast.error("Please fill all course outcomes");
            break; // Exit the loop
          } else {
            outcomes.push({
              outcome_slno: i + 1,
              outcome_description: outcomeDescription,
              learning_domain_id: learningDomainIds,
              program_outcome_id: programme_outcome
            });
          }

        } catch (error) {
          console.error("Error processing outcome:", error);
          setMessage("Please fill all course outcomes");
        }
      }

      const id1 = sessionStorage.getItem("id");
      if (outcomes.length == number_of_outcome) {
        http.post(`/Admin/updatecourse/${id1}`, {

          course_name: course_name,
          faculty_id: faculty_id,
          discipline_id: discipline_id,
          offering_discipline_id: awarded_discipline_id,

          // credit_lecture: credit_lecture,
          // credit_tutorial: credit_tutorial,
          // credit_practical: credit_practical,

          course_curriculum_structure_component_id: course_curriculum_structure_component_id,

          // internal_ratio: internal_ratio,
          // external_ratio: external_ratio,

          course_level: course_level,
          outcome_number: number_of_outcome,
          remarks: remarksValue,
          status: status,
          course_component_id: selectedCourseComponentsids,
          course_components: courseComponentDetails,
          total_credit: total_credit,
          total_hours: total_hours,
          outcomes: outcomes,
          semester_id: semesterid,

          // credit: total,

          course_code: coursecode3,
          coursetype: course_ty,
          practical_type: practical_type,

          credit_theory: courseType_theory,
          credit_practical: courseType_practical,

          credit: credit_total,

          aec_group: aec_group,
          minor_id: min_group,
          specialisation_id: ugpspecialisation_group,


          TI_MIN: theoryInternalMin,
          TI_MAX: theoryInternalMax,
          TE_MIN: theoryExternalMin,
          TE_MAX: theoryExternalMax,
          PI_MIN: practicalInternalMin,
          PI_MAX: practicalInternalMax,
          PE_MIN: practicalExternalMin,
          PE_MAX: practicalExternalMax,

          TI: theoryInternalEnabled ? 1 : 0,
          TE: theoryExternalEnabled ? 1 : 0,
          PI: practicalInternalEnabled ? 1 : 0,
          PE: practicalExternalEnabled ? 1 : 0


        }).then(response => {

          if (response.data.status_code === "MSG2") {

            sessionStorage.setItem("message", " Course  Updated Successfully");
            navigate("/admin/course");

          }
        })
          .catch(error => {
            console.error(error);
            if (error.response && error.response.data.status_code === "ERR2") {
              setMessage("Please fill all outcomes");
            } else if (error.response && error.response.data.status_code === "ERR1") {
              const errors = error.response.data?.errors;

              if (errors?.course_code) {
                toast.error(errors.course_code[0]);

                setTimeout(() => {
                  toast.info("Please type new course code");
                }, 1000);

                return; // stop execution
              }

              toast.error(error.response.data.message);
              return;
            }
            // 🔥 FIXED VALIDATION BLOCK
            else if (error.response?.data?.errors?.course_code) {

              toast.error(error.response.data.errors.course_code[0]);

              setTimeout(() => {

                toast.info("Please type new course code");
              }, 1000);

              return;
            }
            else if (error.response.status === 422) {
              setMessage("Please fill mandatory fields");
              toast.error(error.response.data.errors);
            }
            else {
              setMessage("Something Went Wrong");
            }
          });
      }
    }
    else {
      toast.error("An error occured");
      document.getElementById("main_section").scrollIntoView({ behavior: 'smooth', block: 'start' });

    }
  };



  const isdisiplin = () => {
    const faculty_id = document.getElementById('faculty_id').value;
    setFacultyname(parseInt(faculty_id));

  }

  const issemester = () => {
    setLevelflag(true);
    setFalg(true);
    const semester_id = parseInt(document.getElementById('semester_id').value, 10);
    switch (semester_id) {
      case 1:
      case 2:
        setCourselevelData1(1);
        break;
      case 3:
      case 4:
        setCourselevelData1(2);
        break;
      case 5:
      case 6:
        setCourselevelData1(3);
        break;
      case 7:
      case 8:
        setCourselevelData1(4);
        break;

    }
    const fetchData = async () => {

      http.get('/Admin/getcourseComponentStructure', {
        params: {
          semester_id: semester_id,
          scheme_id: schemeId
        }
      }).then(response => {
        setCoursecomponenttypeData(response.data);
        course_code()
      }).catch(error => {
        console.error('Error fetching Course data:', error);
      });

    };

    fetchData();
  }


  const course_code = async () => {


    setErrors(prevErrors => ({
      ...prevErrors,
      ccoursecode: ""
    }));

    setIsEditable(false);
    setFalgedit(true);


    const discipline_id = document.getElementById('discipline_id').value;
    const semesterid = document.getElementById('semester_id').value;
    const course_curriculum_structure_component_id = document.getElementById('coursecomponentstype').value;
    //console.log("course_curriculum_structure_component_id==", course_curriculum_structure_component_id)

    if (course_curriculum_structure_component_id == 1 || course_curriculum_structure_component_id == 12) {
      setAecflag(true);
      setMinorflag(false);

    }
    else if (course_curriculum_structure_component_id == 5 || course_curriculum_structure_component_id == 6 || course_curriculum_structure_component_id == 7) {

      http.get(`/Admin/getminor`, {
        params: {
          discipline: discipline_id
        }
      }).then(response => {

        setMinorData(response.data);
        setMinorflag(true);
        setAecflag(false);
        setugpspecialisationflag(false);
        setugpspecialisation([]);


      })
        .catch(error => {
          setMinorData([]);
          setMinorflag(false);
          setAecflag(false);
        })

    }
    else if (course_curriculum_structure_component_id == 8 || course_curriculum_structure_component_id == 33 || course_curriculum_structure_component_id == 34 || course_curriculum_structure_component_id == 35) {

      http.get(`/Admin/getugpspecialisation`, {
        params: {
          discipline: discipline_id
        }
      }).then(response => {

        setugpspecialisation(response.data);
        setugpspecialisationflag(true);
        setMinorflag(false);
        setAecflag(false);
        setMinorData([]);


      })
        .catch(error => {
          setugpspecialisation([]);
          setugpspecialisationflag(false);
          setMinorflag(false);
          setAecflag(false);
        })

    }
    else {
      setAecflag(false);
      setMinorflag(false);
    }

    if (discipline_id && semesterid && course_curriculum_structure_component_id) {
      try {
        const response = await http.get('/Admin/coursecodegeneration', {
          params: {
            semester_id: semesterid,
            discipline_id: discipline_id,
            course_curriculum_structure_component_id: course_curriculum_structure_component_id
          }
        });
        const courseCode = response.data.slice(0, -3);
        const courseCode3digit = response.data.slice(-3);

        setCoursecode(courseCode);
        setCoursecodedigit(courseCode3digit)

      } catch (error) {
        setMessage("Something went wrong");
        console.error('Error fetching Course data:', error);
      }
    } else {
      setCoursecode(false);
      setCoursecodedigit(false);

    }
  };

  const toggleEdit = () => {
    setIsEditable(!isEditable);
  };

  const coursecodechange = (e) => {
    const value = e.target.value;
    const semesterid = parseInt(document.getElementById('semester_id').value, 10);
    let minRange, maxRange;

    switch (semesterid) {
      case 1:
      case 2:
        minRange = 100;
        maxRange = 199;
        break;
      case 3:
      case 4:
        minRange = 200;
        maxRange = 299;
        break;
      case 5:
      case 6:
        minRange = 300;
        maxRange = 399;
        break;
      case 7:
      case 8:
        minRange = 400;
        maxRange = 499;
        break;
      default:
        minRange = 100;
        maxRange = 199;
        break;
    }

    if (value && value >= minRange && value <= maxRange) {
      setErrors(prevErrors => ({
        ...prevErrors,
        ccoursecode: ""
      }));
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        ccoursecode: `Enter a value between ${minRange} and ${maxRange}`
      }));
    }
  }
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };


  useEffect(() => {

    if (course.length > 0) {

      if (course[0].course_curriculum_structure_component_id == 5 || course[0].course_curriculum_structure_component_id == 6 || course[0].course_curriculum_structure_component_id == 7) {

        http.get(`/Admin/getminor`, {
          params: {
            discipline: course[0].discipline_id
          }
        }).then(response => {

          setMinorData(response.data);
          setMinorflag(true);
          setAecflag(false);

        }).catch(error => {
          setMinorflag(false);
          setAecflag(false);
        })
      }

      if (course[0].course_curriculum_structure_component_id == 8) {

        http.get(`/Admin/getugpspecialisation`, {
          params: {
            discipline: course[0].discipline_id
          }
        }).then(response => {

          setugpspecialisation(response.data);
          setugpspecialisationflag(true);
          setMinorflag(false);
          setAecflag(false);

        })
          .catch(error => {
            setugpspecialisation([]);
            setugpspecialisationflag(false);
            setMinorflag(false);
            setAecflag(false);
          })

      }


      setAecflag(course[0].aec_group > 0 ? true : false)
      setCourseType(course[0].coursetype)
      setTheoryExternalEnabled(course[0].TE > 0 ? true : false)
      setPracticalExternalEnabled(course[0].PE > 0 ? true : false)
      setTheoryInternalEnabled(course[0].TI > 0 ? true : false)
      setPracticalInternalEnabled(course[0].PI > 0 ? true : false)
      setLectureCredit1(course[0].credit_theory > 0 ? course[0].credit_theory : 0)
      setPracticalCredit1(course[0].credit_practical > 0 ? course[0].credit_practical : 0)
      setTotalCredit(course[0].credit)


    }


  }, [course])

  return (

    <>
      <ToastContainer />
      <Template>
        {course.length === 0 ? (

          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        ) :
          (
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12" >
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Edit Course</h5>
                        </div>
                      </div>

                      <div id="main_section" className="card-body">

                        {message && (
                          <div className="alert alert-danger mar2" role="alert">
                            <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                          </div>
                        )}
                        {commonError && (
                          <div className="alert alert-danger mar2" role="alert">
                            <p style={{ textAlign: 'center', textJustify: 'auto' }}> {commonError}</p>
                          </div>
                        )}
                        <div className="card-body pdg">
                          <div className="table-responsive">
                            <div className="card-body custom-input">

                              <div className="row">
                                <div className="col">
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Course Title  <span className="errorclr">*</span></label>
                                    <div className="col-sm-5">


                                      <input className="form-control input-air-primary" type="text" id="course_code" name="course_code" placeholder="Course Title" defaultValue={course[0].course_name} />
                                      {errors.cname && <p className="text-danger">{errors.cname}</p>}



                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Faculty Name  <span className="errorclr">*</span></label>
                                    <div className="col-sm-5">
                                      <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={isdisiplin} required>
                                        <option value={0} >Select Faculty</option>

                                        {faculty.map(facultys => (



                                          <option value={facultys.id} selected={course[0].faculty_id === facultys.id ? 'selected' : null}>{facultys.faculty_name}</option>


                                        ))}


                                      </select>
                                      {errors.cfaculty && <p className="text-danger">{errors.cfaculty}</p>}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">

                                    <label className="col-sm-7">Discipline  <span className="errorclr">*</span></label>
                                    <div className="col-sm-5">
                                      <select className="form-control form-select scrollable-bar-select" id="discipline_id" name="discipline_id" onChange={handleDisciplineChange} required>
                                        <option value={0}>Select Discipline</option>
                                        {discipline.map(disciplines => (
                                          disciplines.faculty_id === facultyname && (
                                            <option
                                              key={disciplines.id}
                                              value={disciplines.id}
                                              selected={course[0].discipline_id === disciplines.id}>
                                              {disciplines.discipline_name}
                                            </option>
                                          )
                                        ))}
                                      </select>
                                      {errors.cdiscipline && <p className="text-danger">{errors.cdiscipline}</p>}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Awarded Discipline  <span className="errorclr">*</span></label>
                                    <div className="col-sm-5">
                                      <select className="form-control form-select scrollable-bar-select" id="awarded_discipline_id" name="awarded_discipline_id" onChange={(event) => setSelectedAwardedDisciplineId(event.target.value)} required>
                                        <option value={0}>Select Awarded Discipline </option>
                                        {discipline.map(disciplines => (
                                          disciplines.faculty_id === facultyname && (
                                            <option
                                              key={disciplines.id}
                                              value={disciplines.id}
                                              selected={course[0].offering_discipline_id === disciplines.id}>
                                              {disciplines.discipline_name}
                                            </option>
                                          )
                                        ))}
                                      </select>
                                      {errors.cawardedDiscipline && <p className="text-danger">{errors.cawardedDiscipline}</p>}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Semester</label>
                                    <div className="col-sm-5">
                                      <select className="form-control form-select scrollable-bar-select" id="semester_id" name="semester_id" onChange={issemester} required>
                                        <option value={0} >Select Semester</option>

                                        {semester.map(semesters => (



                                          <option value={semesters.id} selected={course[0].semester_id === semesters.id ? 'selected' : null}>{semesters.semester_name}</option>


                                        ))}


                                      </select>
                                      {errors.csemester && <p className="text-danger">{errors.csemester}</p>}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Select Course Component Type  <span className="errorclr">*</span></label>
                                    <div className="col-sm-5">
                                      <select className="form-control form-select scrollable-bar-select" id="coursecomponentstype" name="coursecomponentstype" onChange={course_code} required>
                                        <option value="">---Select---</option>

                                        {flag ? (
                                          coursecomponentstypes.length > 0 && (coursecomponentstypes.map(coursecomponentstype => (
                                            <option
                                              key={coursecomponentstype.course_curriculum_structure_component_id}
                                              value={coursecomponentstype.course_curriculum_structure_component_id}
                                            >
                                              {coursecomponentstype.course_discipline_component}
                                            </option>
                                          )))
                                        ) : (
                                          coursecomponentstypes.length > 0 &&
                                          (coursecomponentstypes.map(coursecomponentstype => (
                                            <option
                                              value={coursecomponentstype.course_curriculum_structure_component_id}
                                              selected={
                                                course[0].course_curriculum_structure_component_id ===
                                                  coursecomponentstype.course_curriculum_structure_component_id ? 'selected' : null
                                              }
                                            >
                                              {coursecomponentstype.course_discipline_component}
                                            </option>
                                          ))
                                          ))}

                                      </select>
                                      {errors.ccurriculum && <p className="text-danger">{errors.ccurriculum}</p>}

                                    </div>
                                  </div>

                                  {aecflag && (

                                    <div className="mb-3 row">
                                      <label className="col-sm-7">AEC Group  <span className="errorclr">*</span></label>
                                      <div className="col-sm-5">
                                        <select className="form-control form-select scrollable-bar-select" id="aec_group" name="aec_group" defaultValue={course[0].aec_group || ''} required>
                                          <option value="0">---Select---</option>
                                          <option value="1">Humanities</option>
                                          <option value="2">Science</option>
                                          <option value="3" >Commerce</option>
                                        </select>
                                        {errors.caecgroup && <p className="text-danger">{errors.caecgroup}</p>}
                                      </div>
                                    </div>

                                  )}

                                  {minorflag && (

                                    <div className="mb-3 row">
                                      <label className="col-sm-7">Minor Group  <span className="errorclr">*</span></label>
                                      <div className="col-sm-5">
                                        <select className="form-control form-select scrollable-bar-select" id="minor_group" name="minor_group" required>
                                          <option value="">---Select---</option>
                                          {minordata.map(minor => (
                                            <option key={minor.id} value={minor.id} selected={course[0].minor_id === minor.id ? 'selected' : null}>
                                              {minor.minors}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.caecgroup && <p className="text-danger">{errors.caecgroup}</p>}
                                      </div>
                                    </div>

                                  )}
                                  {ugpspecialisationflag && (

                                    <div className="mb-3 row" id="spec_row">
                                      <label className="col-sm-7">Specialisation  <span className="errorclr">*</span></label>
                                      <div className="col-sm-5">
                                        <select className="form-control form-select scrollable-bar-select" id="ugpspecialisation_group" name="ugpspecialisation_group" required>
                                          <option value="">---Select---</option>
                                          <option value="56" selected={course[0].specialisation_id == 56 ? true : undefined}>Not Applicable</option>

                                          {ugpspecialisation.map(spec => (
                                            <option key={spec.ugp_specialisation_id} value={spec.ugp_specialisation_id} selected={course[0].specialisation_id == spec.ugp_specialisation_id ? true : undefined}>
                                              {spec.ugp_specialisation_name}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.specialisation && <p className="text-danger">{errors.specialisation}</p>}
                                      </div>
                                    </div>

                                  )}
                                  {/* Old code without signature course code section */}
                                  {/* {flagedit ? (
                                    <div className="mb-3 row">
                                      <label className="col-sm-7">Course Code</label>
                                      <div className="col-sm-5">

                                        <div className="input-container">
                                          <span class="non-editable" id="nonEditable">{coursecode ? coursecode : ""}</span>
                                          {isEditable ? (

                                            <input type="number" class="form-control editable" id="inlineFormCourseCode" defaultValue={coursecodedigit} onChange={coursecodechange} required />

                                          ) : (
                                            <>

                                              <input type="number" class="form-control editable" id="inlineFormCourseCode" placeholder="Course Code" value={coursecodedigit ? coursecodedigit : ''} readOnly onClick={toggleEdit} />

                                            </>
                                          )}
 

                                        </div>
                                        {errors.ccoursecode && <p className="text-danger">{errors.ccoursecode}</p>}
                                      </div>

                                    </div>

                                  ) : (

                                    <div className="mb-3 row">
                                      <label className="col-sm-7">Course Code</label>
                                      <div className="col-sm-5">
                                        <div className="input-container">
                                          <span class="non-editable" id="nonEditable">{course[0].course_code ? course[0].course_code.slice(0, -3) : ""}</span>


                                          {isEditable ? (

                                            <input type="text" class="form-control editable" id="inlineFormCourseCode" defaultValue={course[0].course_code ? course[0].course_code.slice(-3) : ""} onChange={coursecodechange} maxLength={3} required />

                                          ) : (
                                            <>

                                              <input type="text" class="form-control editable" id="inlineFormCourseCode" placeholder="Course Code" value={course[0].course_code ? course[0].course_code.slice(-3) : ""} maxLength={3} readOnly onClick={toggleEdit} />

                                            </>
                                          )}

                                        </div>
                                        {errors.ccoursecode && <p className="text-danger">{errors.ccoursecode}</p>}
                                      </div>

                                    </div>

                                  )

                                  } */}
                                  {/* Old code without signature course code section  end*/}
                                  {/* New code with signature course code section */}


                                  {signatureCourseData.length > 0 ? (
                                    // -----------------------------
                                    // CASE: Signature Course Found
                                    // -----------------------------
                                    flagedit ? (
                                      <div className="mb-3 row">
                                        <label className="col-sm-7">
                                          <p style={{ PaddingTop: '15px' }}>Course Code</p>

                                        </label>
                                        <div className="col-sm-5">
                                          <p style={{ color: '#545454', fontSize: '11px' }}>Signature course code is not editable</p>

                                          <div className="input-container">
                                            <span className="non-editable" id="nonEditable">
                                              {coursecode ? coursecode : ""}
                                            </span>
                                            <input
                                              type="number"
                                              className="form-control editable"
                                              id="inlineFormCourseCode"
                                              value={coursecodedigit ? coursecodedigit : ''}
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="mb-3 row">
                                        <label className="col-sm-7">
                                          <p style={{ PaddingTop: '15px' }}>Course Code</p>
                                        </label>
                                        <div className="col-sm-5">
                                          <p style={{ color: '#545454', fontSize: '11px' }}>Signature course code is not editable</p>
                                          <div className="input-container">
                                            <span className="non-editable" id="nonEditable">
                                              {course[0].course_code ? course[0].course_code.slice(0, -3) : ""}
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control editable"
                                              id="inlineFormCourseCode"
                                              value={course[0].course_code ? course[0].course_code.slice(-3) : ""}
                                              maxLength={3}
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  ) : (
                                    // -----------------------------
                                    // CASE: Normal Editable Course
                                    // -----------------------------
                                    flagedit ? (
                                      <div className="mb-3 row">
                                        <label className="col-sm-7">Course Code</label>
                                        <div className="col-sm-5">
                                          <div className="input-container">
                                            <span className="non-editable" id="nonEditable">
                                              {coursecode ? coursecode : ""}
                                            </span>
                                            {isEditable ? (
                                              <input
                                                type="number"
                                                className="form-control editable"
                                                id="inlineFormCourseCode"
                                                defaultValue={coursecodedigit}
                                                onChange={coursecodechange}
                                                required
                                              />
                                            ) : (
                                              <input
                                                type="number"
                                                className="form-control editable"
                                                id="inlineFormCourseCode"
                                                placeholder="Course Code"
                                                value={coursecodedigit ? coursecodedigit : ''}
                                                readOnly
                                                onClick={toggleEdit}
                                              />
                                            )}
                                          </div>
                                          {errors.ccoursecode && <p className="text-danger">{errors.ccoursecode}</p>}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="mb-3 row">
                                        <label className="col-sm-7">Course Code</label>
                                        <div className="col-sm-5">
                                          <div className="input-container">
                                            <span className="non-editable" id="nonEditable">
                                              {course[0].course_code ? course[0].course_code.slice(0, -3) : ""}
                                            </span>
                                            {isEditable ? (
                                              <input
                                                type="text"
                                                className="form-control editable"
                                                id="inlineFormCourseCode"
                                                defaultValue={
                                                  course[0].course_code ? course[0].course_code.slice(-3) : ""
                                                }
                                                onChange={coursecodechange}
                                                maxLength={3}
                                                required
                                              />
                                            ) : (
                                              <input
                                                type="text"
                                                className="form-control editable"
                                                id="inlineFormCourseCode"
                                                placeholder="Course Code"
                                                value={
                                                  course[0].course_code ? course[0].course_code.slice(-3) : ""
                                                }
                                                maxLength={3}
                                                readOnly
                                                onClick={toggleEdit}
                                              />
                                            )}
                                          </div>
                                          {errors.ccoursecode && <p className="text-danger">{errors.ccoursecode}</p>}
                                        </div>
                                      </div>
                                    )
                                  )}
                                  {/* New code with signature course code section end*/}



                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Course Type<span className="errorclr">*</span></label>
                                    <div className="col-sm-5">
                                      <select className="form-control form-select scrollable-bar-select" id="courseidoftype" name="courseType"
                                        onChange={(e) => {
                                          if (e.target.value === 'T') {
                                            setPracticalExternalEnabled(false);
                                            setPracticalInternalEnabled(false);
                                            setTheoryExternalEnabled(true);
                                            setTheoryInternalEnabled(true);

                                          }
                                          else if (e.target.value === 'P') {
                                            setTheoryExternalEnabled(false);
                                            setTheoryInternalEnabled(false);
                                            setPracticalExternalEnabled(true);
                                            setPracticalInternalEnabled(true);

                                          }
                                          else if (e.target.value === 'B') {
                                            setTheoryExternalEnabled(true);
                                            setTheoryInternalEnabled(true);
                                            setPracticalExternalEnabled(true);
                                            setPracticalInternalEnabled(true);

                                          }
                                          setCourseType(e.target.value);
                                          setTotalCredit(0);
                                        }}
                                        defaultValue={course[0].coursetype || ''}
                                      >

                                        <option value="0" >---Select---</option>
                                        <option value="T" >Theory(T)</option>
                                        <option value="P">Practical(P)</option>
                                        <option value="B">Both(B)</option>
                                      </select>

                                      {errors.ccoursetype && <p className="text-danger">{errors.ccoursetype}</p>}
                                    </div>
                                  </div>

                                  {courseType === 'P' && (
                                    <div className="mb-3 row" id="pract_row">
                                      <label className="col-sm-7">Practical Category<span className="errorclr">*</span></label>
                                      <div className="col-sm-5">
                                        <select
                                          className="form-control form-select"
                                          id="practicalType"
                                          name="practicalType"
                                          onChange={(e) => setPracticalCategoryType(e.target.value)}
                                          defaultValue={course[0].practical_type || ''}
                                        >
                                          <option value="">---Select---</option>
                                          <option value="P">Practical(P)</option>
                                          <option value="PJ">Project(PJ)</option>
                                          <option value="D">Dissertation(D)</option>
                                          <option value="I">Internship(I)</option>
                                          <option value="V">Viva(V)</option>

                                        </select>

                                        {errors.practicalType && <p className="text-danger">{errors.practicalType}</p>}
                                      </div>
                                    </div>

                                  )}

                                  {courseType != false && (


                                    <div className="row">
                                      <label className="col-sm-7">Credit</label>
                                      <div className="col-sm-5">
                                        <div className="row">
                                          {(courseType === 'T' || courseType === 'B') && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="lecture" name="lecture" placeholder="Theory" onChange={(e) => setLectureCredit1(e.target.value)} Value={lectureCredit1} />
                                            </div>
                                          )}
                                          {(courseType === 'P' || courseType === 'B') && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="tutorial" name="tutorial" placeholder="Practical" onChange={(e) => setPracticalCredit1(e.target.value)} Value={practicalCredit1} />
                                            </div>
                                          )}


                                          <div className="col-md-4 col-sm">
                                            <input type="text" className="form-control" id="total" name="total" placeholder="Total" Value={totalCredit} disabled />
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <h5 id="Mark_Details" className="pdg3">Mark Details</h5>
                                  <div className="mb-3 row">
                                    <div className="container box1">
                                      <div className="row g-4">
                                        {(courseType === 'T' || courseType === 'B') && (
                                          <>
                                            <div className="col-md-6">
                                              <div className="border rounded p-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <label className="form-label fw-bold mb-0">Theory Internal</label>
                                                  <div className="form-check form-switch">
                                                    {/* Avoid checkbox for avoinding disable */}

                                                    {/* <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      onChange={(e) => setTheoryInternalEnabled(e.target.checked)}
                                                      checked={theoryInternalEnabled}

                                                    /> */}
                                                  </div>
                                                </div>
                                                <div className="row g-2">
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Min"
                                                      name="theoryMin"
                                                      disabled={!theoryInternalEnabled}
                                                      id='theoryMin'
                                                      defaultValue={course[0].TI_MIN}
                                                    />
                                                  </div>
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Max"
                                                      name="theoryMax"
                                                      disabled={!theoryInternalEnabled}
                                                      id='theoryMax'
                                                      defaultValue={course[0].TI_MAX}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="col-md-6">
                                              <div className="border rounded p-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <label className="form-label fw-bold mb-0">Theory External</label>
                                                  <div className="form-check form-switch">
                                                    {/* Avoid checkbox for avoinding disable */}

                                                    {/* <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      onChange={(e) => setTheoryExternalEnabled(e.target.checked)}
                                                      checked={theoryExternalEnabled}

                                                    /> */}
                                                  </div>
                                                </div>
                                                <div className="row g-2">
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Min"
                                                      name="theoryExternalMin"
                                                      disabled={!theoryExternalEnabled}
                                                      id='theoryExternalMin'
                                                      defaultValue={course[0].TE_MIN}
                                                    />
                                                  </div>
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Max"
                                                      name="theoryExternalMax"
                                                      disabled={!theoryExternalEnabled}
                                                      id='theoryExternalMax'
                                                      defaultValue={course[0].TE_MAX}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}

                                        {(courseType === 'P' || courseType === 'B') && (
                                          <>
                                            <div className="col-md-6">
                                              <div className="border rounded p-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <label className="form-label fw-bold mb-0">Practical Internal</label>
                                                  <div className="form-check form-switch">
                                                    {/* Avoid checkbox for avoinding disable */}

                                                    {/* <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      onChange={(e) => setPracticalInternalEnabled(e.target.checked)}
                                                      id="practicalInternalEnabled"
                                                      checked={practicalInternalEnabled}

                                                    /> */}

                                                  </div>
                                                </div>
                                                <div className="row g-2">
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Min"
                                                      name="practicalInternalMin"
                                                      disabled={!practicalInternalEnabled}
                                                      id='practicalInternalMin'
                                                      defaultValue={course[0].PI_MIN}
                                                    />
                                                  </div>
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Max"
                                                      name="practicalInternalMax"
                                                      disabled={!practicalInternalEnabled}
                                                      id='practicalInternalMax'
                                                      defaultValue={course[0].PI_MAX}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="col-md-6">
                                              <div className="border rounded p-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <label className="form-label fw-bold mb-0">Practical External</label>
                                                  <div className="form-check form-switch">
                                                    {/* Avoid checkbox for avoinding disable */}

                                                    {/* <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      onChange={(e) => setPracticalExternalEnabled(e.target.checked)}
                                                      id="practicalExternalEnabled"
                                                      checked={practicalExternalEnabled}

                                                    /> */}

                                                  </div>
                                                </div>
                                                <div className="row g-2">
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Min"
                                                      name="practicalExternalMin"
                                                      disabled={!practicalExternalEnabled}
                                                      defaultValue={course[0].PE_MIN}
                                                      id='practicalExternalMin'
                                                    />
                                                  </div>
                                                  <div className="col-6">
                                                    <input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Max"
                                                      name="practicalExternalMax"
                                                      disabled={!practicalExternalEnabled}
                                                      defaultValue={course[0].PE_MAX}
                                                      id='practicalExternalMax'
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>







                                  <h5 id="" className="pdg3">Course components</h5>

                                  <div className="mb-3 row">
                                    <div className="container box1">
                                      <div className="mb-3 row">
                                        <label className="col-sm-7">Select Course component</label>
                                        <div className="col-sm-5">
                                          {!truet ? (
                                            <Select
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control"
                                              id="coursecomponent"
                                              name="coursecomponent"
                                              isMulti
                                              options={coursecomponent.map(coursecomponents => ({
                                                value: coursecomponents.id,
                                                label: coursecomponents.course_component,
                                              }))}

                                              value={coursecomponent.filter(coursecomponents => {
                                                const componentIds = JSON.parse(course[0].concatenated_course_components_id);
                                                return componentIds.includes(coursecomponents.id);
                                              }).map(selectedComponent => ({
                                                value: selectedComponent.id,
                                                label: selectedComponent.course_component
                                              }))}
                                              required


                                              onChange={handleCourseComponentChange}
                                            />
                                          ) : (
                                            <Select
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              className="form-control"
                                              id="coursecomponent"
                                              name="coursecomponent"
                                              isMulti
                                              options={coursecomponent.map(coursecomponents => ({
                                                value: coursecomponents.id,
                                                label: coursecomponents.course_component
                                              }))}
                                              onChange={handleCourseComponentChange}
                                              required
                                            />
                                          )}

                                        </div>
                                      </div>
                                      {/* <div className="mb-3 row">
                                    <label className="col-sm-7">Lecture, Tutorial, Practical Credit Ratio Credit Distribution (L:T:P)</label>
                                    <div className="col-sm-5">
                                      {!truet ? (
                                        <div className="row">
                                          {showLecture && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="lecture" name="lecture" placeholder="L" defaultValue={course[0]?.credit_lecture ?? ""} onChange={handleLectureCreditChange} />
                                            </div>
                                          )}
                                          {showTutorial && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="tutorial" name="tutorial" placeholder="T" defaultValue={course[0]?.credit_tutorial ?? ""} onChange={handleTutorialCreditChange} />
                                            </div>
                                          )}
                                          {showPracticumLab && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="practical" name="practical" placeholder="P" defaultValue={course[0]?.credit_practical ?? ""} onChange={handlePracticalCreditChange} />
                                            </div>
                                          )}
                                        </div>
                                      ) : (
                                        <div className="row">
                                          {showLecture && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="lecture" name="lecture" placeholder="L" required defaultValue={null} onChange={handleLectureCreditChange} />
                                            </div>
                                          )}
                                          {showTutorial && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="tutorial" name="tutorial" placeholder="T" required defaultValue={null} onChange={handleTutorialCreditChange} />
                                            </div>
                                          )}
                                          {showPracticumLab && (
                                            <div className="col-md-4 col-sm">
                                              <input type="text" className="form-control" id="practical" name="practical" placeholder="P" defaultValue={null} onChange={handlePracticalCreditChange} />
                                            </div>
                                          )}
                                        </div>

                                      )}
                                    </div>
                                  </div> */}


                                      {Object.keys(componentWiseData).length > 0 && (
                                        <div className="credit-hours-section">
                                          <h6 className="section-title">Credits & Hours</h6>

                                          <div className="row">
                                            {Object.entries(componentWiseData).map(([id, data]) => (
                                              <div className="col-md-6 mb-3" key={id}>
                                                <div className="component-card">
                                                  <div className="component-title">
                                                    {data.componentName}
                                                  </div>

                                                  <div className="row g-2">
                                                    <div className="col-6">
                                                      <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Total Credit"
                                                        value={data.total_credit}
                                                        onChange={(e) =>
                                                          setComponentWiseData(prev => ({
                                                            ...prev,
                                                            [id]: {
                                                              ...prev[id],
                                                              total_credit: e.target.value
                                                            }
                                                          }))
                                                        }
                                                      /> {errors.componentErrors?.[id]?.total_credit && (
                                                        <p className="text-danger mt-2">
                                                          {errors.componentErrors[id].total_credit}
                                                        </p>
                                                      )}
                                                    </div>

                                                    <div className="col-6">
                                                      <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Total Hours"
                                                        value={data.total_hours}
                                                        onChange={(e) =>
                                                          setComponentWiseData(prev => ({
                                                            ...prev,
                                                            [id]: {
                                                              ...prev[id],
                                                              total_hours: e.target.value
                                                            }
                                                          }))
                                                        }
                                                      /> {errors.componentErrors?.[id]?.total_hours && (
                                                        <p className="text-danger mt-2">
                                                          {errors.componentErrors[id].total_hours}
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}

                                    </div>
                                  </div>


                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Level of Course  <span className="errorclr">*</span></label>
                                    <div className="col-sm-5">
                                      <select className="form-control " id="courselevel_id" name="courselevel_id" required readOnly>
                                        <option value={0} >---Select---</option>
                                        {levelflag ? (

                                          courselevel.map(courselevels => (
                                            courselevels.id == courselevel1 && (
                                              <option value={courselevels.id} selected>{courselevels.course_level}</option>
                                            )
                                          ))

                                        ) : (
                                          courselevel.map(courselevels => (
                                            <option value={courselevels.id} selected={course[0].course_level_id === courselevels.id ? 'selected' : null} >{courselevels.course_level}</option>
                                          ))
                                        )}

                                      </select>
                                      {errors.clevel && <p className="text-danger">{errors.clevel}</p>}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">No. of Course Outcomes</label>
                                    <div className="col-sm-5">
                                      {/*  <select className="form-control form-select scrollable-bar-select" id="courseoutcome" name="courseoutcome" onChange={handleCourseOutcomeChange} required>
                                        {/* {[...Array(Math.max(0, 9 - totalCredit)).keys()].map((value) => (
                                          <option key={value} value={value + totalCredit}>{value + totalCredit}</option>
                                        ))} */}
                                      {/*
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                      </select> */}
                                      <select


                                        className="form-control form-select scrollable-bar-select"
                                        id="courseoutcome"
                                        name="courseoutcome"
                                        value={numSections}
                                        onChange={handleCourseOutcomeChange}
                                        required
                                      >
                                        {[...Array(11).keys()].map((value) => (
                                          <option key={value} value={value + 1}>
                                            {value + 1}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <h5 className="pdg3">CO Statements</h5>
                                <div className="mb-3 row">
                                  <div className="container box1">
                                    <div className="row">
                                      <div className="col-md-1 col-sm">
                                      </div>
                                      <div className="col-md-3 col-sm">
                                        <label>State the Course Outcomes</label>
                                      </div>
                                      <div className="col-md-4 col-sm">
                                        <label>Select the Corresponding Learning Domain</label>
                                      </div>
                                      <div className="col-md-4 col-sm">
                                        <label>Enter the Corresponding PO</label>
                                      </div>
                                    </div>

                                    {sectionsData.map((section, index) => (
                                      <div key={index} className="row pdg3">
                                        <div className="col-md-1 col-sm">
                                          <label>{`CO:${index + 1}`}</label>
                                        </div>
                                        <div className="col-md-3 col-sm">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id={`outcome${index}`}
                                            name={`outcome${index}`}
                                            placeholder=""
                                            defaultValue={outcomee[index] ? outcomee[index].outcome_description : ''}
                                            required
                                          />
                                        </div>
                                        <div className="col-md-4 col-sm">
                                          {!truet2 ? (
                                            <Select
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control ht"
                                              id={`domains${index}`}
                                              name={`domains${index}`}
                                              isMulti
                                              options={learningdomain.map(learningdomains => ({
                                                value: learningdomains.id,
                                                label: learningdomains.learning_domain
                                              }))}
                                              value={learningdomain.filter(learningdomains => {
                                                if (!outcomee[index]) return false;
                                                const concatenatedDomains = outcomee[index].concatenated_learning_domains.split(',').map(domain => domain.trim());
                                                return concatenatedDomains.includes(learningdomains.learning_domain);
                                              }).map(selectedOption => ({
                                                value: selectedOption.id,
                                                label: selectedOption.learning_domain
                                              }))}
                                              onChange={(selectedOptions) => handleDomainChange(selectedOptions, index)}
                                              required

                                            />
                                          ) : (
                                            <Select
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control ht"
                                              id={`domains${index}`}
                                              name={`domains${index}`}
                                              multiple
                                              aria-label="multiple select example"
                                              required
                                              isMulti
                                              value={selectedDomainOptions[index]}
                                              onChange={(selectedOptions) => handleDomainChange(selectedOptions, index)}
                                              options={learningoptions}
                                            />
                                          )}
                                        </div>
                                        <div className="col-md-4 col-sm">
                                          {!truet1 ? (
                                            <Select
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control ht"
                                              id={`outcomeDomains${index}`}
                                              name={`outcomeDomains${index}`}
                                              isMulti
                                              options={programmeoutcome.map(programmeoutcomes => ({
                                                value: programmeoutcomes.id,
                                                label: programmeoutcomes.programme_outcome
                                              }))}
                                              value={programmeoutcome.filter(programmeoutcomes => {
                                                if (!outcomee[index]) return false; // If outcomee[index] is falsy, return false
                                                const concatenatedOutcomes = outcomee[index].concatenated_programme_outcomes.split(',').map(outcome => outcome.trim());
                                                return concatenatedOutcomes.includes(programmeoutcomes.programme_outcome);
                                              }).map(selectedOption => ({
                                                value: selectedOption.id,
                                                label: selectedOption.programme_outcome
                                              }))}
                                              onChange={(selectedOptions) => handleOutcomeChange(selectedOptions, index)}
                                              required
                                            />
                                          ) : (
                                            <Select
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control ht"
                                              id={`outcomeDomains${index}`}
                                              name={`outcomeDomains${index}`}
                                              multiple
                                              aria-label="multiple select example"
                                              required
                                              isMulti
                                              value={selectedOutcomeOptions[index]}
                                              onChange={(selectedOptions) => handleOutcomeChange(selectedOptions, index)}
                                              options={outcomeoptions}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    ))}

                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-7">Remarks</label>
                                  <div className="col-sm-5">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" defaultValue={course[0].remarks} onChange={(e) => setRemarks(e.target.value)} />
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 txt-aln">
                            <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                            <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                          </div>





                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div >
            </div >


          )
        }

      </Template >

    </>

  );
}
